import type { LegalContent } from './legal.ts';

// Yasal metinler — Türkçe.
//
// Bu metinler UYDURULMADI: her madde kodda gerçekten olan bir davranışı
// anlatır (hangi tablonun neyi tuttuğu, hangi isteğin nereye gittiği tek tek
// kontrol edildi). Ürün davranışı değişirse buranın da değişmesi gerekir.
//
// Ton: resmî, "siz" hitabı, madde yapısı. Sohbet üslubu ve kişisel yorumlar
// kaldırıldı; olgular korundu.
//
// Hukuki denetim AYRI bir iştir: metinler mevcut uygulamayı doğru anlatır,
// ancak KVKK ve tüketici mevzuatına uygunluğu bir hukukçu tarafından
// onaylanmadan bağlayıcı belge sayılmamalıdır. Sayfa bunu açıkça belirtir.

export const legalTr: LegalContent = {
  title: 'Yasal bilgiler',
  updated: 'Son güncelleme: 13 Ekim 2026',
  note: 'Bu metinler yazılımın gerçekten yaptığı işi anlatır ve ürün değiştikçe güncellenir.',
  sections: [
    {
      key: 'terms',
      label: 'Kullanım Koşulları',
      blocks: [
        {
          title: '1. Hizmetin tanımı',
          body: [
            '{brand}, bir oynatıcı ve kitaplık yazılımıdır. Kanal, film veya dizi paketi satmaz. ' +
            'Kişisel IPTV özelliği, hâlihazırda sahip olduğunuz bir M3U veya Xtream kaynağını bu ' +
            'oynatıcıda kullanmanızı sağlar; söz konusu kaynağın aboneliği ve içeriğin hukuka uygunluğu ' +
            'sizinle sağlayıcınız arasındaki ilişkiye tabidir.',
            'Uygulamada ayrıca iki tür hazır içerik yer alır: serbestçe yayın yapan televizyon ' +
            'kanallarının canlı akışları ve YouTube üzerindeki videolar. Her ikisi de kaynağından ' +
            'alınarak sunucumuz üzerinden size iletilir.',
          ],
        },
        {
          title: '2. Hazır kanallar ve videolar',
          body: [
            'Hazır içerik bölümü, televizyon kanallarının açık yayın akışlarını ve YouTube videolarını ' +
            'sunucumuz üzerinden iletir.',
            'Yayıncılarla yapılmış bir dağıtım anlaşması veya lisans bulunmamaktadır. YouTube içeriği ' +
            'YouTube’un kendi hizmet şartlarına tabidir. Bu bölüm, hak sahiplerinden gelecek bir bildirim ' +
            'üzerine veya kendi kararımızla, önceden haber verilmeksizin kaldırılabilir; kaldırılması ' +
            'hizmetin diğer özelliklerini etkilemez.',
            'Ücretli paketler içerik değil, oynatıcı özellikleri sunar: YouTube videolarında günlük süre ' +
            'sınırının kalkması ve Plus paketinde kendi listenizi ekleyebilmeniz.',
            'Hazır kanallar, ücretsiz paket dâhil bütün paketlerde süre sınırı olmadan açıktır. Hiçbir ' +
            'paketin ücreti bu kanallar karşılığında alınmaz.',
          ],
        },
        {
          title: '3. Hesap',
          body: [
            'Hesap açmak için geçerli bir e-posta adresi ve en az 8 karakterden oluşan bir parola gerekir. ' +
            'Hesabınızı üçüncü kişilerle paylaşmanız hâlinde bu paylaşımdan doğan kullanımdan siz sorumlusunuz.',
            'Hesabınızı dilediğiniz zaman Ayarlar ekranından silebilirsiniz. Silme işlemiyle birlikte ' +
            'kaynaklarınız, favorileriniz, izleme geçmişiniz ve cihaz kayıtlarınız da silinir; yedeklerdeki ' +
            'kopyalar en geç 14 gün içinde silinir.',
            'Hizmeti kullanabilmek için 18 yaşını doldurmuş olmanız gerekir. 18 yaşından küçük kişiler ' +
            'hesap açamaz.',
          ],
        },
        {
          title: '4. Aynı anda tek yayın',
          body: [
            'Hesap başına aynı anda yalnızca bir yayın açılabilir. Bu sınır tüm paketlerde aynıdır ve ' +
            'artırılamaz; ürünün çalışma biçiminin bir parçasıdır.',
            'Başka bir cihazda yayın başlattığınızda, önceki yayın durdurulduktan sonra yenisi açılır. ' +
            'İki yayın aynı anda akmaz.',
          ],
        },
        {
          title: '5. Ücretsiz paketin sınırı',
          body: [
            'Ücretsiz pakette YouTube videoları için her gün toplam 30 dakika oynatma hakkı bulunur. Hazır ' +
            'kanallar bu süreden düşmez. Bu süre hesap genelinde ' +
            'tutulur: sayfayı yenilemek, cihaz değiştirmek veya yeniden giriş yapmak süreyi sıfırlamaz. ' +
            'Sayaç her gün Türkiye saatiyle gece yarısı (00.00) sıfırlanır.',
            'Süre dolduğunda oynatma durur ve kaldığınız konum kaydedilir.',
          ],
        },
        {
          title: '6. Kabul edilmeyen kullanım',
          body: [
            'Aşağıdaki durumlar hesabın askıya alınmasına yol açabilir:',
            { list: [
              'Hizmeti, erişim hakkınız bulunmayan içeriğe ulaşmak için kullanmak.',
              'Tek yayın sınırını veya günlük süre sınırını aşmaya yönelik teknik girişimlerde bulunmak.',
              'Sunucuya otomatik ve aşırı istek göndermek.',
              'Başka kullanıcıların hesaplarına erişmeye çalışmak.',
            ] },
          ],
        },
        {
          title: '7. Hizmetin sürekliliği ve sorumluluk',
          body: [
            'Kesinti, veri kaybı veya özellik değişikliği yaşanabilir. Belirli bir çalışma süresi (uptime) ' +
            'taahhüdü verilmemektedir.',
            'Cihaz uyumluluğu garanti edilmez; desteklenen tarayıcı ve cihazlar Uyumluluk sayfasında ' +
            'belirtilmiştir.',
            'Hizmet “olduğu gibi” sunulur. Kesinti veya veri kaybından doğan dolaylı zararlardan sorumluluk ' +
            'kabul edilmez; kasıt ve ağır kusur hâlleri saklıdır.',
          ],
        },
        {
          title: '8. Hesabın askıya alınması',
          body: [
            'Yukarıdaki kurallara aykırı kullanım tespit edilmesi hâlinde hesap askıya alınabilir. Bu durumda ' +
            'İletişim bölümündeki adrese yazarak gerekçeyi öğrenebilir ve itiraz edebilirsiniz. ' +
            'İtirazlar otuz gün içinde değerlendirilir.',
          ],
        },
        {
          title: '9. Koşulların değişmesi',
          body: [
            'Bu metinler ürün geliştikçe güncellenir. Önemli bir değişiklikte sayfanın başındaki “son ' +
            'güncelleme” tarihi değişir. Bildirimler e-posta ile ' +
            'gönderilmez; değişiklikleri bu sayfadan takip etmeniz gerekir. Değişiklikten sonra hizmeti kullanmaya devam etmeniz, yeni koşulları kabul ettiğiniz ' +
            'anlamına gelir.',
          ],
        },
        {
          title: '10. Uygulanacak hukuk',
          body: [
            'Bu koşullara Türkiye Cumhuriyeti hukuku uygulanır. Uyuşmazlıklarda tüketici hakem heyetleri ve ' +
            'tüketici mahkemeleri yetkilidir.',
          ],
        },
      ],
    },
    {
      key: 'privacy',
      label: 'Gizlilik Politikası',
      blocks: [
        {
          title: '1. Toplanan veriler',
          body: [
            'Hizmetin çalışması, ölçülmesi ve sorunların tespiti için gereken veriler toplanır:',
            { list: [
              'Hesap: e-posta adresiniz, parolanızın karması (parolanın kendisi hiçbir yerde saklanmaz) ve varsa girdiğiniz ad.',
              'Cihaz: tarayıcınızın bildirdiği cihaz türünden üretilen bir ad (“Telefon”, “Araç ekranı” gibi) ve son görülme zamanı.',
              'Oturum: tarayıcınızda tutulan oturum çerezi; sunucuda yalnızca bu jetonun karması saklanır.',
              'Kaynak: eklediğiniz M3U/Xtream adresi, kullanıcı adı ve parolası. Şifreli saklanır (AES-256-GCM) ve kayıtlara (log) yazılmaz.',
              'İzleme: ne izlediğiniz, kaldığınız konum, favorileriniz ve günlük kullandığınız toplam süre.',
              'Kullanım kaydı: uygulamadaki hareketlerinizin (giriş, açtığınız ekran, arama ve arama metni, oynatma başlangıcı ve bitişi, seçilen kalite, duraklatma, ileri/geri alma, takılma, tam ekran, favori, kaynak ekleme/silme, paket işlemleri) zamanı ve hangi cihaz türünden yapıldığı. IP adresi bu kayda yazılmaz. Kayıt, hizmetin kullanımını ölçmek ve sorunları tespit etmek için tutulur.',
              'Bağlantı kalitesi ölçümü: oynatma sırasında görüntü takılırsa nedenin bağlantınız mı yoksa kaynak mı olduğunu ayırt etmek için tarayıcınızın bildirdiği teknik değerler kaydedilir: indirme hızı, gecikme süresi, bağlantı türü (örneğin 4g), tampon süresi ve takılma sayısı. Bu değerler izlenen içerik ve cihaz türüyle birlikte kullanım kaydına ve uygulama kayıtlarına yazılır; konum bilgisi veya IP adresi içermez.',
              'Ödeme: kart bilgisi bu hizmette istenmez ve saklanmaz.',
            ] },
          ],
        },
        {
          title: '2. Parola ve kaynak bilgileri',
          body: [
            'Hesap parolanız scrypt ile tek yönlü olarak özetlenir (hash); geri çevrilemez ve tarafımızca görüntülenemez. Kaynağınızın ' +
            'kullanıcı adı ve parolası AES-256-GCM ile şifreli saklanır ve yalnızca yayın açılırken çözülür. ' +
            'Hata kayıtlarında adres ve kimlik bilgileri maskelenir; bu davranış otomatik testlerle korunur.',
          ],
        },
        {
          title: '3. Üçüncü taraflara giden veriler',
          body: [
            'Üçüncü taraf analiz aracı, reklam izleyicisi veya sosyal medya pikseli kullanılmaz. Yalnızca ' +
            'oturum çerezi bulunur; reklam çerezi yoktur.',
            'Teknik zorunluluktan doğan aşağıdaki aktarımlar mevcuttur:',
            { list: [
              'Video küçük görselleri doğrudan Google’ın sunucusundan (i.ytimg.com) yüklenir; tarayıcınızın IP adresi Google’a ulaşır.',
              'Kendi IPTV listenizi eklediyseniz kanal ve afiş logoları doğrudan sağlayıcınızdan yüklenir; tarayıcınızın IP adresi o sağlayıcıya ulaşır. Görüntü ve ses için durum farklıdır (aşağıya bakınız).',
              'Arama yaptığınızda arama metni sunucumuz üzerinden sağlayıcıya iletilir; IP adresiniz iletilmez.',
              'Video ve ses verisi sunucumuz üzerinden akar. Bu akışta içerik sağlayıcı sizin değil, sunucumuzun adresini görür.',
              'Parola sıfırlama istediğinizde ve aboneliğinizle ilgili işlem bildirimlerinde (satın alma, tahsilat, ödemenin alınamaması, iptal ve deneme süresi bitiş hatırlatması) e-posta adresiniz ve iletinin içeriği, gönderilmek üzere e-posta hizmet sağlayıcısına (Resend, ABD) iletilir. Bunların dışında size e-posta gönderilmez; tanıtım amaçlı ileti gönderilmez.',
            ] },
          ],
        },
        {
          title: '4. Saklama süreleri',
          body: [
            { list: [
              'Hesap ve kaynak bilgileri: hesabınız açık olduğu sürece.',
              'Oturum jetonları: 30 gün; çıkış yaptığınızda veya cihazı kaldırdığınızda derhal geçersiz olur. Geçersiz kayıtlar 30 gün sonra silinir.',
              'Günlük kullanım sayacı: kota hesabı için tutulur, 90 gün sonra silinir.',
              'Cihaz kayıtları: oturumu kalmamış ve 180 gündür görülmeyen cihazlar silinir.',
              'Yayın oturumu geçmişi (zaman, cihaz, başlık, aktarılan veri miktarı): 90 gün, sonra silinir.',
              'Kullanım kaydı (hareket günlüğü): 2 yıl. Hesabınızı sildiğinizde kayıtlar hesabınızla ve cihazınızla bağını yitirir, arama metinleri silinir; kayıtlar yalnızca kimliksiz toplam istatistik olarak kalır.',
              'Hız sınırı sayaçları: IP adresine bağlıdır, kimlikle eşleştirilmez ve 24 saat sonra silinir.',
              'Parola sıfırlama bağlantıları: 60 dakika geçerlidir; kullanıldığında derhal, kullanılmadığında süresi dolduktan sonra en geç 24 saat içinde silinir.',
              'Yayın rehberi (EPG) önbelleği: 7 gün.',
              'Ödeme kayıtları (işlem türü, paket, tutar, tarih, ödeme sağlayıcısındaki işlem ve abonelik numaraları): hesabınız açık olduğu sürece hesabınızla birlikte; hesabınızı sildiğinizde hesabınızla bağı kesilerek 10 yıl, sonra silinir.',
              'Uygulama kayıtları (log): en fazla 30 gün ve 500 MB. Parola ve kaynak bilgisi içermez.',
              'Web sunucusu erişim kaydı: istenen adres, zaman, IP adresi ve tarayıcı bilgisiyle birlikte 14 gün tutulur. IP adresi KVKK anlamında kişisel veridir; bu kayıt kötüye kullanımın tespiti amacıyla tutulur.',
              'Yedekler: veritabanının günlük yedeği alınır ve 14 kopya saklanır.',
            ] },
          ],
        },
        {
          title: '5. Haklarınızın kullanımı',
          body: [
            'Hesabınızı Ayarlar ekranından kendiniz silebilirsiniz; parolanızı onayladığınızda hesabınız ve ' +
            'bağlı tüm kayıtlar veritabanından silinir.',
            'Üç istisna vardır. Birincisi yedeklerdir: veritabanının günlük yedeği alındığından, silinen ' +
            'hesabın bir kopyası en geç 14 gün boyunca yedeklerde kalır ve ardından silinir.',
            'İkincisi deneme süresi kaydıdır: deneme süresini kullanmış bir hesap silinirse, e-posta ' +
            'adresinin geri çevrilemeyen bir özeti saklanır. Adresin kendisi tutulmaz; bu kayıt yalnızca aynı ' +
            'adresle yeniden açılan hesaba deneme süresinin ikinci kez tanınmaması için kullanılır.',
            'Üçüncüsü ödeme kayıtlarıdır: ödeme sağlayıcısı üzerinden işlem yaptıysanız, işlemin türü, ' +
            'paketi, tutarı, tarihi ve ödeme sağlayıcısındaki işlem ve abonelik numaraları ticari kayıt ' +
            'olarak 10 yıl saklanır ve ardından silinir. Bu kayıtlar hesabınızla bağı kesilerek tutulur; ' +
            'e-posta adresiniz, adınız ve cihaz bilgileriniz bu kayıtlarda yer almaz.',
            'Verilerinizin bir kopyasını talep etmek veya düzeltme istemek için İletişim bölümündeki adrese ' +
            'yazabilirsiniz.',
          ],
        },
      ],
    },
    {
      key: 'cookies',
      label: 'Çerez Politikası',
      blocks: [
        {
          title: '1. Kullanılan çerezler',
          body: [
            'Yalnızca bir çerez kullanılır: oturum çerezi. Reklam çerezi, ölçümleme çerezi veya üçüncü taraf ' +
            'çerezi yazılmaz.',
            'Onay gerektiren, zorunlu olmayan bir çerez bulunmadığından “çerezleri kabul et” penceresi ' +
            'gösterilmez. Bu sayfadaki bilgiler mevcut uygulamayı anlatır; hukuki nitelendirme bir hukukçunun ' +
            'değerlendirmesine tabidir.',
          ],
        },
        {
          title: '2. Oturum çerezi',
          body: [
            { list: [
              'Adı: akis_session.',
              'Amacı: giriş yaptıktan sonra sizi tanımak. Bu çerez olmadan her istekte yeniden giriş gerekir.',
              'Ömrü: 30 gün. Çıkış yaptığınızda veya cihazı kaldırdığınızda derhal geçersiz olur.',
              'Ayarları: HttpOnly (JavaScript okuyamaz), SameSite=Lax (başka siteden gönderilmez), HTTPS üzerinde Secure.',
              'İçeriği: rastgele bir jeton. Sunucuda jetonun kendisi değil, karması saklanır.',
            ] },
          ],
        },
        {
          title: '3. Tarayıcıda tutulan diğer kayıtlar',
          body: [
            'Çerez olmayan ve yalnızca cihazınızda saklanan birkaç küçük kayıt vardır. Bu kayıtların kendisi sunucuda tutulmaz; ancak seçtiğiniz dil ve kalite isteklerle birlikte, yaptığınız arama ise arama anında sunucuya iletilir:',
            { list: [
              'Seçtiğiniz görüntü kalitesi (örneğin 720p).',
              'Son aramalarınız; arama ekranındaki “Temizle” ile silebilirsiniz.',
              'Arayüz dili tercihiniz.',
              'Hangi ekran düzeninde çalıştığınız (telefon / araç / bilgisayar).',
              'Sekme kapanınca silinen iki kayıt: araçtaki sürüş uyarısını görmüş olduğunuz bilgisi ve yeni sürüm için tek seferlik yenileme işareti.',
            ] },
            'Tarayıcının site verilerini temizlemesi bu kayıtların tamamını siler.',
          ],
        },
      ],
    },
    {
      key: 'kvkk',
      label: 'KVKK Aydınlatma Metni',
      blocks: [
        {
          title: '1. Aydınlatma',
          body: [
            '6698 sayılı Kişisel Verilerin Korunması Kanunu (KVKK) kapsamında, hangi verilerinizin hangi ' +
            'amaçla işlendiği aşağıda açıklanmaktadır.',
            'Veri sorumlusu: hizmeti şu anda bireysel olarak yürüten geliştiricidir. İletişim bölümündeki ' +
            'adresten ulaşabilirsiniz. Ticari faaliyete geçildiğinde ticaret unvanı ve adres bu bölüme eklenecektir.',
            'Veriler, hesap oluştururken doldurduğunuz form aracılığıyla ve hizmeti kullandığınız sırada ' +
            'otomatik yollarla, elektronik ortamda toplanır.',
          ],
        },
        {
          title: '2. İşlenen veriler ve amaçları',
          body: [
            { list: [
              'Kimlik ve iletişim (e-posta, varsa ad): hesabın oluşturulması ve girişin doğrulanması.',
              'İşlem güvenliği (parola karması, oturum jetonu karması, cihaz adı, son görülme zamanı): hesabınızın yetkisiz kullanımının önlenmesi.',
              'Kullanım verileri (izlenen içerik, kalınan konum, favoriler, günlük toplam süre): hizmetin çalışması ve paket haklarının uygulanması.',
              'Kullanım kaydı (hareket günlüğü: zaman, hareket türü, cihaz türü, içerik ve kalite, arama metni ve bağlantı kalitesi ölçümleri): hizmet kullanımının ölçülmesi, sorunların tespiti ve yasal yükümlülüklerin yerine getirilmesi.',
              'Kaynak bilgileri (IPTV adresiniz, kullanıcı adınız ve parolanız): yalnızca talimatınızla o kaynağa bağlanmak. Şifreli saklanır.',
              'Kısa ömürlü IP sayaçları: kötüye kullanımın ve otomatik saldırıların sınırlandırılması.',
            ] },
          ],
        },
        {
          title: '3. Hukuki sebep',
          body: [
            'Hesap ve hizmet verileri sözleşmenin kurulması ve ifası kapsamında (KVKK m.5/2-c); güvenlik ' +
            'sayaçları ise meşru menfaat kapsamında (KVKK m.5/2-f) işlenir. Açık rıza gerektiren bir işleme ' +
            'yapılmamaktadır: pazarlama amaçlı profilleme, reklam izleme veya veri satışı yoktur.',
          ],
        },
        {
          title: '4. Aktarım ve sunucunun yeri',
          body: [
            'Kişisel verileriniz satılmaz ve pazarlama amacıyla üçüncü taraflara aktarılmaz. Teknik ' +
            'zorunluluktan doğan aktarımlar Gizlilik Politikası’nda tek tek belirtilmiştir: video küçük ' +
            'görselleri Google sunucusundan, kendi listenizi eklediyseniz kanal logoları sağlayıcınızdan ' +
            'doğrudan tarayıcınıza gelir; arama metni sunucumuz üzerinden iletilir.',
            'Parola sıfırlama istediğinizde ve aboneliğinizle ilgili işlem bildirimlerinde e-posta adresiniz, iletinin ' +
            'gönderilebilmesi için yurt dışında yerleşik e-posta hizmet sağlayıcısına (Resend, ABD) aktarılır.',
            'Verileriniz hizmetin çalıştığı sunucuda saklanır. Sunucunun bulunduğu ülkenin yurt dışı olması ' +
            'hâlinde bu durum KVKK m.9 anlamında yurt dışına aktarım sayılır; bu husus ticari faaliyete ' +
            'geçilmeden önce netleştirilerek burada açıkça belirtilecektir.',
          ],
        },
        {
          title: '5. Haklarınız',
          body: [
            'KVKK m.11 kapsamında verilerinize erişme, düzeltme, silme ve işlemeye itiraz etme haklarına ' +
            'sahipsiniz. Başvurunuzu İletişim bölümündeki adrese iletebilirsiniz; başvurular en geç otuz gün ' +
            'içinde yanıtlanır. Hesabınızı Ayarlar ekranından silmeniz, verilerinizin silinmesi anlamına gelir ' +
            '(yedeklerdeki kopya 14 gün içinde silinir).',
            'Bir veri ihlali yaşanması hâlinde etkilenen kullanıcılara ve ilgili kuruma mevzuatın öngördüğü ' +
            'süre içinde bildirim yapılır.',
          ],
        },
      ],
    },
    {
      key: 'subscription',
      label: 'Abonelik ve İptal',
      blocks: [
        {
          title: '1. Paketler ve fiyatlar',
          body: [
            'Üç paket bulunur: Ücretsiz (YouTube için günde 30 dakika, kişisel IPTV yok), Başlangıç (120,00 TL/ay; ' +
            'kişisel IPTV yok) ve Plus (249,00 TL/ay; kendi M3U veya Xtream listenizi ekleyebilirsiniz). ' +
            'Fiyatlara KDV dâhildir.',
            'Ücretli paketler yıllık olarak da alınabilir. Yıllık ödemede 12 aylık kullanım için 10 aylık ' +
            'ücret alınır: Başlangıç 1.200,00 TL/yıl, Plus 2.490,00 TL/yıl. Yıllık dönem 365 gündür.',
            'Ücretli bir pakete ilk kez geçen hesaba 7 günlük deneme süresi tanınır. Deneme süresinde ücret ' +
            'alınmaz; süre bitmeden iptal ederseniz hiç ücret ödemezsiniz, iptal etmezseniz süre sonunda ' +
            'seçtiğiniz dönemin ücreti alınır. Deneme süresi hesap başına yalnızca bir kez geçerlidir. ' +
            'Tutar ve yenileme dönemi ödeme adımında yeniden gösterilir.',
            'Plus paketinde aynı anda iki kaynak (M3U veya Xtream) tanımlanabilir; bu sayı sınırsız değildir.',
            'Sınırsız kullanım taahhüdü verilmez; adil kullanım ilkesi uygulanır ve olası sınırlar önceden ' +
            'duyurulur.',
          ],
        },
        {
          title: '2. Ödeme',
          body: [
            'Ödemeler iyzico altyapısıyla alınır. Kart bilgilerinizi iyzico’nun formuna girersiniz; kart ' +
            'bilgisi bu siteye ulaşmaz ve burada saklanmaz. Kartınız iyzico tarafından 1 TL’lik bir işlemle ' +
            'doğrulanabilir; bu tutar iade edilir.',
            'Abonelik açılırken iyzico’nun zorunlu tuttuğu ad, soyad, T.C. kimlik numarası, cep telefonu ve ' +
            'fatura adresi sizden istenir. Bu bilgiler yalnızca iyzico’ya iletilir; bu sitede saklanmaz.',
            'Ödeme sistemi deneme (test) aşamasındayken ödeme sayfasında bu açıkça yazar ve gerçek tahsilat ' +
            'yapılmaz. Fatura düzeni gerçek tahsilat başlamadan önce bu bölüme eklenecektir; iade koşulları ' +
            'aşağıda “Cayma hakkı ve iade” başlığındadır.',
          ],
        },
        {
          title: '3. Yenileme ve iptal',
          body: [
            'Abonelik, seçtiğiniz ödeme dönemine göre 30 günlük (aylık) veya 365 günlük (yıllık) dönemler hâlinde yenilenir. İptal ettiğinizde erişiminiz derhal kesilmez: ' +
            'içinde bulunduğunuz dönemin sonuna kadar tüm özellikler açık kalır; dönem sonunda hesabınız ' +
            'Ücretsiz pakete döner. İptal hâlinde, içinde bulunduğunuz dönemin kullanılmayan süresi için ' +
            'ücret iadesi yapılmaz.',
            'İptal işlemi Paketler ekranından yapılır. Ödeme sağlayıcısı üzerinden açılan abonelikte iptal geri ' +
            'alınamaz; dönem bitmeden yeniden abone olursanız yeni abonelik satın aldığınız gün başlar ve mevcut ' +
            'dönemin kalan süresi eklenmez.',
            'Paketinizi, ödeme döneminiz aynı kalmak koşuluyla Paketler ekranından değiştirebilirsiniz. Üst ' +
            'pakete geçtiğinizde yeni paketin özellikleri hemen açılır ve içinde bulunduğunuz dönem için ek ' +
            'ücret alınmaz; yeni fiyat bir sonraki dönemden itibaren uygulanır. Alt pakete geçiş, içinde ' +
            'bulunduğunuz dönemin sonunda uygulanır. Deneme süresinde yapılan değişiklik hemen geçerli olur ' +
            've deneme sonunda yeni paketin ücreti alınır. Ödeme dönemini (aylık ya da yıllık) değiştirmek ' +
            'için aboneliğin iptal edilip yeniden başlatılması gerekir.',
            'Ödeme kartınızı Paketler ekranından, ödeme sağlayıcısının formu üzerinden değiştirebilirsiniz. ' +
            'Kart bilgisi bu sitede tutulmadığı için kartınız bu sitede görüntülenemez.',
            'Plus paketinden düştüğünüzde kişisel IPTV erişiminiz kapanır; eklediğiniz kaynaklar ve katalog ' +
            'kayıtlarınız silinmez, yeniden Plus’a geçtiğinizde erişim geri açılır.',
          ],
        },
        {
          title: '4. Cayma hakkı ve iade',
          body: [
            'Hizmet, satın alma tamamlandığı anda elektronik ortamda sunulmaya başlar. Ödeme adımında ' +
            'hizmetin hemen başlamasını istediğinizi ve bu nedenle cayma hakkınızın bulunmadığını ' +
            'onaylarsınız; elektronik ortamda anında ifa edilen hizmetler, Mesafeli Sözleşmeler ' +
            'Yönetmeliği’nde cayma hakkının istisnaları arasında sayılır.',
            'Ücretli bir pakete ilk kez geçtiğinizde tanınan 7 günlük deneme süresi, hizmeti ücret ödemeden ' +
            'değerlendirmeniz içindir: bu süre içinde iptal ederseniz sizden ücret alınmaz.',
            'Tahsil edilen ücretler iade edilmez. Aboneliğinizi iptal ettiğinizde yeni dönem için ücret ' +
            'alınmaz ve içinde bulunduğunuz dönemin sonuna kadar hizmeti kullanmaya devam edersiniz.',
            'Hatalı ya da mükerrer bir tahsilat yapıldığını düşünüyorsanız İletişim bölümündeki adrese yazın; ' +
            'inceleme sonunda haksız alındığı anlaşılan tutar iade edilir.',
            'Uyuşmazlık hâlinde, Ticaret Bakanlığı’nca her yıl ilan edilen parasal sınırlar içinde ' +
            'yerleşim yerinizdeki Tüketici Hakem Heyeti’ne veya Tüketici Mahkemesi’ne başvurabilirsiniz.',
          ],
        },
      ],
    },
    {
      key: 'safety',
      label: 'Araç İçi Güvenlik',
      blocks: [
        {
          title: '1. Sürüş sırasında video izlenmez',
          body: [
            'Bu ürün araç ekranlarında da çalışacak şekilde tasarlanmıştır. Temel kural şudur: araç hareket ' +
            'hâlindeyken sürücü video izlemez.',
            'Video izlemek dikkat dağıtır ve bulunduğunuz ülkede yasak olabilir. Sürücünün hareket hâlindeki ' +
            'araçta ekrana bakması trafik mevzuatına aykırıdır ve doğacak sorumluluk sürücüye aittir.',
          ],
        },
        {
          title: '2. Alınan önlemler',
          body: [
            { list: [
              'Araç ekranında uzun metin girişi gerektiren işlemler (kaynak ekleme) telefona devredilir.',
              'Araç düzeninde dokunma hedefleri büyütülür ve metin okunur boyuta çıkarılır; böylece ekrana bakış süresi kısalır.',
              'Aracın, sürüş sırasında videoyu kısıtlayan önlemlerini aşmaya yönelik hiçbir işlem yapılmaz. Tam ekran yalnızca aracın park hâlinde sunduğu Tiyatro kipi üzerinden ve sizin onayınızla açılır.',
            ] },
          ],
        },
        {
          title: '3. Teknik sınırlar',
          body: [
            'Aracın hareket hâlinde olup olmadığı tarayıcıdan öğrenilemez; bu bilgi web sayfalarına ' +
            'verilmez. Bu nedenle oynatma otomatik olarak durdurulamaz. Aracın kendi sistemi bu kısıtı ' +
            'uyguluyorsa ona müdahale edilmez.',
            'Sorumluluk sürücüye aittir. Uygulama yolcular için tasarlanmıştır.',
          ],
        },
      ],
    },
    {
      key: 'copyright',
      label: 'Telif Hakları',
      blocks: [
        {
          title: '1. İçeriğin kaynağı',
          body: [
            'Hiçbir içerik sunucularımızda saklanmaz; içerik yalnızca oynatma sırasında aktarılır. Üç ayrı ' +
            'kaynak vardır ve her birinin durumu farklıdır:',
            { list: [
              'Kendi IPTV listeniz: eklediğiniz M3U/Xtream kaynağından gelir. Bu kaynağın hukuka uygunluğu sizin sorumluluğunuzdadır.',
              'Hazır canlı kanallar: televizyon kanallarının açık yayın akışlarından alınır ve sunucumuz üzerinden iletilir. Yayıncılarla dağıtım anlaşması bulunmamaktadır.',
              'Keşfet ve arama: YouTube üzerindeki videolar, yine sunucumuz üzerinden iletilir.',
            ] },
            'Son iki kalem, hak sahiplerinden gelecek bir bildirim üzerine kaldırılır. Erişim hakkınız bulunmayan içeriği bu hizmet üzerinden izlemek Kullanım ' +
            'Koşulları’na aykırıdır.',
          ],
        },
        {
          title: '2. Hak sahipleri için bildirim',
          body: [
            'Bir kullanıcının hizmet üzerinden haklarınızı ihlal ettiğini düşünüyorsanız, İletişim bölümündeki ' +
            'adrese aşağıdaki bilgilerle başvurabilirsiniz:',
            { list: [
              'Hak sahibi olduğunuzu gösteren bilgi.',
              'Söz konusu eserin tanımı.',
              'İhlalin nerede gerçekleştiğine ilişkin bilgi (hesap, tarih, içerik adı).',
              'İletişim bilgileriniz ve beyanınızın doğruluğuna ilişkin ifadeniz.',
            ] },
            'Bildirimler değerlendirilir. Hazır kanallar veya Keşfet bölümündeki videolarla ilgili bir ' +
            'bildirimde ilgili yayın gecikmeksizin kaldırılır. Kullanıcı kaynaklarında ilgili kaynak kaldırılır; ' +
            'tekrarlayan ihlalde hesap askıya alınır. 5651 sayılı Kanun kapsamındaki yükümlülükler, ticari ' +
            'faaliyete geçilmesiyle birlikte ayrıca düzenlenecektir.',
          ],
        },
        {
          title: '3. Kullanılan açık kaynak bileşenler',
          body: [
            'Arayüz yazı tipi Manrope’tur (SIL Open Font License 1.1). Oynatma yolunda mp4box.js, ffmpeg ve ' +
            'yt-dlp kullanılır; her biri kendi lisansına tabidir. Tanıtım sayfasındaki illüstrasyonlar bu proje ' +
            'için üretilmiştir ve gerçek bir katalog görseli değildir.',
          ],
        },
      ],
    },
    {
      key: 'contact',
      label: 'İletişim',
      blocks: [
        {
          title: '1. Bize ulaşın',
          body: [
            'Destek, gizlilik başvurusu, telif bildirimi ve diğer tüm sorularınız için:',
            { contact: 'iletisim@akisplay.com' },
            'Başvurular en geç otuz gün içinde yanıtlanır.',
          ],
        },
        {
          title: '2. Hizmeti işleten',
          body: [
            'Bu hizmet bireysel olarak yürütülmektedir ve çevrim içi tahsilat yapılmamaktadır. Çevrim içi ' +
            'satışa geçildiğinde ticaret unvanı, adres, vergi numarası ve ETBİS kayıt bilgileri bu bölüme ' +
            'eklenir; mesafeli satış sözleşmesi ve ön bilgilendirme formu da o aşamada yayımlanır.',
          ],
        },
      ],
    },
  ],
};
